import { render, staticRenderFns } from "./WorldMap.vue?vue&type=template&id=1d7c65e2&"
import script from "./WorldMap.vue?vue&type=script&lang=js&"
export * from "./WorldMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d7c65e2')) {
      api.createRecord('1d7c65e2', component.options)
    } else {
      api.reload('1d7c65e2', component.options)
    }
    module.hot.accept("./WorldMap.vue?vue&type=template&id=1d7c65e2&", function () {
      api.rerender('1d7c65e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WorldMap/WorldMap.vue"
export default component.exports